<!--
 * @Description: 
-->
<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.className"
        placeholder="班级名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
    };
  },
  created() {
  },
  methods: {
    initData() {
      const filters = { ...this.filters }
      this.$emit("search", { ...filters });
    },
    resetData() {
      this.filters = {};
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
